import React, { useEffect, useState } from 'react';
import './ForgotPasswordPage.scss';
import { forgotPassword } from '../../data/api';
import { NavLink } from 'react-router-dom';
import { Bounce, ToastContainer, toast } from 'react-toastify';


const ForgotPasswordPage = ({}) => {

    const [mail, setMail] = useState('')
    const [success, setSuccess] = useState(true)
    
        
    const handleSubmit = async (e) => {
        e.preventDefault();
        // Aquí puedes agregar la lógica para enviar el correo electrónico ingresado por el usuario
        const resp = await forgotPassword(mail)
        if(resp.status == 'success') {
            localStorage.setItem('resetToken', resp.token)
            setSuccess(false)
            toast.success('Correo enviado', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Bounce,
                });
        } else {
            toast.error(resp.error, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Bounce,
                });
        }
    };

    return (
        <div className="forgot-password-page">
            <div className="forgot-container">
                {success ? (
                    <>
                        <h2>Restablecimiento de contraseña</h2>
                        <p>Por favor, ingresa tu correo electrónico para restablecer tu contraseña.</p>
                        <form onSubmit={handleSubmit}>
                            <input type="email" id="email" name="email" value={mail} onChange={(e) => setMail(e.target.value)} placeholder='Correo electrónico' required />
                            <button type="submit">Enviar</button>
                        </form>
                        <NavLink className="btn-back" to='/'>Regresar</NavLink>
                    </>
                ) : (
                    <>
                        <h2>Correo de reestablecimiento de contraseña enviado</h2>
                        <p>Revisa tu bandeja de entrada para poder reestablecer tu contraseña. No olvides revisar la carpeta de spam.</p>
                    </>
                )}
                
            </div>
            
        <ToastContainer
            position="bottom-right"
            autoClose={5000}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover={false}
            theme="dark"
            transition={Bounce}
            />
        </div>
    );
};

export default ForgotPasswordPage;
